module.exports = __webpack_public_path__ + "static/media/locked.f6924b7f.svg";